module.exports = __webpack_public_path__ + "img/c-en-12.f3457354.png";